import { ILeadPhoneNumber } from "types";

export function getCommaSeparatedPhoneNumberFromArray(
    phoneNumbers: ILeadPhoneNumber[]
): string {
    if (phoneNumbers == null || phoneNumbers.length === 0) return "";
    return phoneNumbers.map((x) => x.internationalNoBlanks).join(", ");
}
